module.exports = __webpack_public_path__ + "img/Weapon_153.41d0a47d.png";